/* OAuth-Client create/edit modal, ported 1:1 from the Claude Design prototype
 * (pim-admin/pages.jsx ClientFormModal). DS Modal/Input/Select/Button supply the
 * shell + fields; these styles reproduce the field labels, chip toggles, URI
 * editor rows, dividers and TKS toggle-rows the DS does not provide. */

.stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.stackSm {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.grid2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--form-gap);
  align-items: start;
}
@media (width <= 600px) {
  .grid2 {
    grid-template-columns: 1fr;
  }
}

.fld {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.label {
  font-size: var(--font-size-s);
  color: var(--color-grey);
}
.hint {
  font-size: var(--font-size-s);
  color: var(--color-grey-light);
}
.error {
  font-size: var(--font-size-s);
  color: var(--color-error);
}
.divider {
  height: 1px;
  background: var(--color-grey-lightest);
  margin: 4px 0;
}

/* monospace inline code (scope hint) */
.fchipMono {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}

/* ── URI editor rows ── */
.uriEditorRow {
  display: flex;
  align-items: center;
  gap: 8px;
}
.uriEditorInput {
  flex: 1;
  min-width: 0;
}

/* ── TKS toggle-rows (design `.toggle-row`) ── */
.toggleRow {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 13px 14px;
  border: 1px solid var(--color-grey-lighter);
  border-radius: var(--border-radius);
  cursor: pointer;
}
.toggleRow input {
  width: 17px;
  height: 17px;
  margin-top: 1px;
  accent-color: var(--color-primary);
  flex-shrink: 0;
  cursor: pointer;
}
.toggleTitle {
  display: block;
  font-size: var(--font-size-m);
}
.toggleSub {
  display: block;
  font-size: var(--font-size-s);
  color: var(--color-grey);
  margin-top: 3px;
  line-height: 1.4;
}

/* monospace input (design `.input.mono`, 12.5px) */
.monoInput :global(input) {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: var(--font-size-s);
}

/* modal footer: hint left, actions right */
.foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}
.footHint {
  font-size: var(--font-size-s);
  color: var(--color-grey-light);
}
.footActions {
  display: flex;
  gap: 8px;
}
